import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import GiftCardProvider from "./comps/store";
import ErrorBoundary from "./comps/error-boundary";
import ChatButton from "./comps/chat-button";
import PinManagement from "./comps/screens/pin-management";
import HelpPage from './comps/screens/helpPage';
import ApplePayPage from './comps/screens/applePayPage';
import GooglePayPage from './comps/screens/googlePayPage';
import './App.css';
import AppDownload from "./comps/screens/app-download";
import i18next from "i18next";
import { RecaptchaProvider } from "./comps/recaptcha";

// Lazy load components
const GiftcardHome = lazy(() => import("./comps/screens/giftcard-home"));
const WalletProvisioning = lazy(() => import("./comps/screens/wallet-provisioning"));



const Footer = () => {
    return <footer>&copy; Agantis 2026</footer>;
};

function App() {
    const brandName = window.location.hostname.split(".").slice(0, -1).join(" ");
    const writingDirection = i18next.dir();

    return (
        <ErrorBoundary>
            <RecaptchaProvider>
                <GiftCardProvider>
                    <div className={"giftcards " + brandName + " langDir-" + writingDirection}>
                        <Router>
                            <Suspense fallback={<div>Loading...</div>}>
                                <Routes>
                                    <Route path="/" element={<GiftcardHome />} />
                                     <Route path="/help" element={<HelpPage />} />
                                    <Route path="/apple-pay" element={<ApplePayPage />} />
                                    <Route path="/google-pay" element={<GooglePayPage />} />
                                    <Route path="/provision" element={<WalletProvisioning />} />
                                    <Route path="/balance/:token" element={<GiftcardHome />} />
                                    <Route path="/:token/change-pin" element={<PinManagement />} />
                                    <Route path="/:token" element={<GiftcardHome />} />
                                    <Route path="/app" element={<AppDownload />} />
                                    <Route path="/dashboard/cards/:token/add" element={<AppDownload />} />
                                    <Route path="/password-reset/:token" element={<AppDownload />} />
                                    <Route path="/:anyOtherPath" element={<AppDownload />} />
                                </Routes>
                            </Suspense>
                            <ChatButton />
                            <Footer />
                        </Router>
                    </div>
                </GiftCardProvider>
            </RecaptchaProvider>
        </ErrorBoundary>
    );
}

export default App;
